import { useTranslation } from 'react-i18next';

import { AMTLICHE_MELDUNG_POST_CATEGORY } from '@/features/post-editor/constants/postCategory';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

/**
 * Resolves the display label of a post's `categories` string. Known
 * language-neutral values (e.g. {@link AMTLICHE_MELDUNG_POST_CATEGORY}) are localized;
 * unknown values (e.g. free-form crawler categories) are passed through raw.
 */
export const useGetPostCategoryLabel = () => {
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'categories'
  });

  return (categories?: string): string | undefined => {
    if (!categories) {
      return undefined;
    }
    if (categories === AMTLICHE_MELDUNG_POST_CATEGORY) {
      return t(AMTLICHE_MELDUNG_POST_CATEGORY);
    }
    return categories;
  };
};
